import { useQuery } from "@tanstack/react-query";
import cmsClient from "src/services/cmsClient";
import { adaptGroup } from "../adapters/adaptGroup";

const fetchAdminGroup = async (id: number) => {
	const response = await cmsClient.get<IGroup>(`/users/groups/${id}/`);

	return response.data;
};

const useAdminGroup = (id: number) => {
	return useQuery(["admin-group", id], () => fetchAdminGroup(id), {
		enabled: id > 0,
		select: adaptGroup
	});
};

export default useAdminGroup;
